var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-card",
    { staticClass: "page-logs-tracking-event-header-lote" },
    [
      _c("template", { attrs: { slot: "header" }, slot: "header" }, [
        _c(
          "h2",
          { staticClass: "has-text-primary is-size-4 card-header-title" },
          [_vm._v("Lote")]
        )
      ]),
      _vm._v(" "),
      _c(
        "template",
        { attrs: { slot: "body" }, slot: "body" },
        [
          _vm.lote.hash
            ? _c("p", { staticClass: "heading" }, [
                _c("strong", [_vm._v("Nome do lote:")])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("span", { staticClass: "hash" }, [_vm._v(_vm._s(_vm.lote.hash))]),
          _vm._v(" "),
          _vm.getLogisticProvider
            ? _c("p", { staticClass: "heading" }, [
                _c("strong", [_vm._v("Transportadora:")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.getLogisticProvider))])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.getOrigin
            ? _c("p", { staticClass: "heading" }, [
                _c("strong", [_vm._v("Origem:")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.getOrigin))])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("sc-button", {
            attrs: {
              theme: "primary",
              text: "Dado original",
              loading: _vm.loadingPayload
            },
            on: { click: _vm.openPayload }
          }),
          _vm._v(" "),
          _vm.getSubflow === "ADD_EVENTS"
            ? _c("sc-button", {
                attrs: {
                  theme: "warning",
                  text: "Reprocessar",
                  loading: _vm.loadingReprocess
                },
                on: { click: _vm.reprocessLote }
              })
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b5c6ca9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b5c6ca9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-analytic/features/logs/pages/tracking/pages/logs-tracking-lote-detail/components/sc-logs-tracking-lote-detail-header/blocks/sc-logs-tracking-lote-detail-header-lote/ScLogsTrackingLoteDetailHeaderLote.vue
// module id = null
// module chunks = 